export default ({transaction: {type = ''} = {}} = {}) => type;
